/** Visually hidden live region so screen readers announce copy success. */
export function MessageCopyStatus({ isCopied }: { isCopied: boolean }) {
  if (!isCopied) return null
  return (
    <span role="status" className="sr-only">
      Copied
    </span>
  )
}
